export function isPastDueSubscription(
  subscription: { status?: string | null } | null | undefined
): boolean {
  const status = subscription?.status?.toLowerCase();
  return status === "past_due" || status === "unpaid";
}

export function subscriptionStatusLabel(status: string | null | undefined): string {
  switch ((status || "").toLowerCase()) {
    case "active":
      return "Active";
    case "trialing":
      return "Trial";
    case "past_due":
      return "Past due";
    case "unpaid":
      return "Unpaid";
    case "canceled":
      return "Canceled";
    case "revoked":
      return "Revoked";
    case "paused":
      return "Paused";
    case "none":
      return "None";
    default:
      return (status || "").replaceAll("_", " ");
  }
}
